const VARIANTS = {
  primary:   'bg-primary-600 hover:bg-primary-700 text-white',
  secondary: 'bg-surface-elevated border border-line hover:bg-surface-hover text-content',
  ghost:     'hover:bg-surface-hover text-content-secondary hover:text-content',
  danger:    'bg-red-600 hover:bg-red-700 text-white',
};

const SIZES = {
  xs: 'px-2 py-1 text-xs gap-1',
  sm: 'px-3 py-1.5 text-xs gap-1.5',
  md: 'px-4 py-2 text-sm gap-2',
  lg: 'px-5 py-2.5 text-sm gap-2',
};

export function Button({ variant = 'primary', size = 'md', icon: Icon, children, loading = false, className = '', ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center font-medium rounded-button transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="3" strokeDasharray="60 30" />
        </svg>
      ) : Icon ? (
        <Icon className={size === 'xs' ? 'w-3 h-3' : size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4'} />
      ) : null}
      {children}
    </button>
  );
}
